/**
 * HelpBody — Зааврын АГУУЛГЫГ зурах цорын ганц компонент.
 *
 * ⚠ ЯАГААД ТУСДАА ГАРГАВ:
 *   Үүнийг ХОЁР газар ашиглана —
 *     1. `PageHelp` — хэрэглэгчийн харах цонх
 *     2. Удирдах хуудасны «Урьдчилан харах»
 *   Хоёрыг тусад нь бичвэл засварлагч урьдчилан харснаас ӨӨР зүйл
 *   хэрэглэгчид харагдах эрсдэлтэй. Нэг эх сурвалжтай байх нь урьдчилан
 *   харахыг ҮНЭН болгож байгаа хэрэг.
 */
import React, { useEffect, useRef, useState } from "react";
import { Button, Image } from "antd";

/** Секундыг «2 мин 30 сек» болгоно — «150 сек» гэж уншихад төвөгтэй */
const durText = (sec) => {
  const n = Number(sec || 0);
  if (!n) return "";
  const m = Math.floor(n / 60);
  const s = Math.round(n % 60);
  return m ? `${m} мин${s ? ` ${s} сек` : ""}` : `${s} сек`;
};

export default function HelpBody({ help }) {
  /* ⚠ ВИДЕО АНХДАГЧААР ХААЛТТАЙ (2026-10-01): тоглуулагч нь цонхны дээд
     талын 200+ пикселийг эзэлж, бичсэн заавар доош түлхэгддэг байв.
     Мөн `preload="metadata"` ч гэсэн хуудас нээх бүрд сүлжээ зардаг.
     «Үзэх» дарсан үед л элемент үүснэ — товшилт нь хэрэглэгчийн
     ЗӨВШӨӨРӨЛ тул autoplay ч хөтчид хоригдохгүй. */
  const [showVideo, setShowVideo] = useState(false);
  /* ⚠ UNMOUNT ДЭЭР ЗОГСООНО (2026-10-14): «хуудас шилжихэд ч юм уу
     цонхны чагтаар хаасан үед бичлэг тоглож үлдэж байсан».
     DOM-оос салгасан `<video>` нь браузер дээр ҮРГЭЛЖ зогсдоггүй —
     дуу нь цаана гарсаар байж болно. Тиймээс илт `pause()` хийж,
     эх сурвалжийг нь салгана (татаж байсан бол тэр ч таслагдана). */
  const videoRef = useRef(null);
  useEffect(
    () => () => {
      const el = videoRef.current;
      if (!el) return;
      try {
        el.pause();
        el.removeAttribute("src");
        el.load();
      } catch {
        /* браузер зөвшөөрөөгүй — тоглуулалт аль хэдийн дууссан байж болно */
      }
    },
    [],
  );

  if (!help) return null;

  return (
    <>
      {help.intro ? (
        <p style={{ color: "#5B6472", marginTop: 0, lineHeight: 1.55 }}>
          {help.intro}
        </p>
      ) : null}

      {/* ── ВИДЕО ЗААВАР (2026-09-30) ──────────────────────────────────
          ⚠ ХАМГИЙН ДЭЭР байрлана: хэрэглэгч бичсэн зааврыг уншихаас
          илүү ХАРАХ нь хурдан бөгөөд «заавал сургалт авах» шаардлагыг
          энэ л бууруулна. Доош байрлуулбал олонх нь олохгүй өнгөрнө.
          `preload="metadata"` — хуудас нээх бүрд хэдэн МБ татахгүй,
          зөвхөн үргэлжлэх хугацаа/эхний кадрыг авна. */}
      {help.video_url ? (
        <div style={{ marginBottom: 12 }}>
          {/* ── ХУРААСАН мөр: нэг товшилтоор нээнэ ───────────────────── */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
              padding: "7px 10px",
              borderRadius: 8,
              border: "1px solid #CFE7DE",
              background: "#F2FAF7",
            }}
          >
            <i
              className="fas fa-circle-play"
              style={{ color: "#0F6E56", fontSize: 15 }}
            />
            <span
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#0F6E56",
                letterSpacing: 0.2,
              }}
            >
              Видео заавар
            </span>
            {help.video_seconds ? (
              <span style={{ fontSize: 11.5, color: "#5B6472" }}>
                · {durText(help.video_seconds)}
              </span>
            ) : null}
            <span style={{ flex: 1 }} />
            <Button
              size="small"
              type={showVideo ? "default" : "primary"}
              style={
                showVideo
                  ? undefined
                  : { background: "#0F6E56", borderColor: "#0F6E56" }
              }
              onClick={() => setShowVideo((v) => !v)}
            >
              <i
                className={"fas " + (showVideo ? "fa-eye-slash" : "fa-play")}
                style={{ marginRight: 5 }}
              />
              {showVideo ? "Нуух" : "Үзэх"}
            </Button>
          </div>

          {showVideo ? (
            <video
              ref={videoRef}
              src={help.video_url}
              controls
              autoPlay
              playsInline
              style={{
                width: "100%",
                maxHeight: 420,
                marginTop: 8,
                borderRadius: 8,
                border: "1px solid #E6E9EF",
                background: "#000",
              }}
            />
          ) : null}
        </div>
      ) : null}

      {/* Хуудасны ерөнхий дэлгэцийн зураг.
          ⚠ Заавар нь НАРИЙН цонхонд гардаг тул бүтэн хуудасны зураг жижгэрч,
             бичээс нь уншигдахгүй. Дарж томруулж болохыг ил хэлж өгөв —
             эс бөгөөс хэрэглэгч зүгээр л «жижиг зураг» гэж өнгөрнө. */}
      {help.image_url ? (
        <div style={{ marginBottom: 10 }}>
          <Image
            src={help.image_url}
            alt={help.image_name || ""}
            style={{
              width: "100%",
              borderRadius: 6,
              border: "1px solid #E6E9EF",
              cursor: "zoom-in",
            }}
          />
          <div
            style={{
              fontSize: 11,
              color: "#8A94A6",
              marginTop: 3,
              textAlign: "center",
            }}
          >
            <i className="fas fa-search-plus" style={{ marginRight: 5 }} />
            Зураг дээр дарж томруулж харна
          </div>
        </div>
      ) : null}

      {/* Алхмууд — ДУГААРЛАСАН нь санаатай: эдгээр нь ДАРААЛАЛТАЙ үйлдэл,
          зүгээр нэг жагсаалт биш. Эхнийхийг алгасвал дараагийнх ажиллахгүй
          (ж: ажлын байраа сонгоогүй бол аюул сонгогдохгүй). */}
      {help.steps?.length ? (
        <ol style={{ paddingLeft: 20, margin: "14px 0 0" }}>
          {help.steps.map((s, i) => (
            <li key={s.id || i} style={{ marginBottom: 12 }}>
              <div style={{ fontWeight: 600, marginBottom: 2 }}>{s.title}</div>
              {s.text ? (
                <div
                  style={{ color: "#5B6472", fontSize: 13, lineHeight: 1.5 }}
                >
                  {s.text}
                </div>
              ) : null}
              {s.image_url ? (
                <Image
                  src={s.image_url}
                  alt={s.image_name || s.title || ""}
                  style={{
                    marginTop: 6,
                    width: "100%",
                    borderRadius: 6,
                    border: "1px solid #E6E9EF",
                  }}
                />
              ) : null}
            </li>
          ))}
        </ol>
      ) : null}

      {/* ── ХЭН ЮУ ХИЙХ ВЭ (түвшингээр) ─────────────────────────────
          ⚠ ЯАГААД ТУСДАА ХЭСЭГ ВЭ: нэг хуудсыг 3-4 өөр түвшний хүн
            хэрэглэдэг ба тэдний ҮЙЛДЭЛ өөр (ажилтан бүртгэнэ · АШУА
            хянана · ХАБЭА хэлтэс хүлээн авна). Алхмуудын дунд хольж
            бичвэл хүн өөрт ХАМААРАХГҮЙ алхмыг уншиж цаг алдана, эсвэл
            «надад эрх байхгүй» гэж андуурна. */}
      {help.roles?.length ? (
        <div style={{ marginTop: 16 }}>
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              color: "#334155",
              marginBottom: 6,
            }}
          >
            Хэн юу хийх вэ
          </div>
          {help.roles.map((r, i) => (
            <div
              key={r.role || i}
              style={{
                display: "flex",
                gap: 8,
                padding: "6px 8px",
                borderLeft: "3px solid #1D4E89",
                background: "#F7F9FC",
                borderRadius: 4,
                marginBottom: 5,
              }}
            >
              <div
                style={{
                  minWidth: 132,
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#1D4E89",
                }}
              >
                {r.role}
              </div>
              <div style={{ fontSize: 12.5, color: "#5B6472", lineHeight: 1.5 }}>
                {r.text}
              </div>
            </div>
          ))}
        </div>
      ) : null}

      {help.notes?.length ? (
        <div
          style={{
            marginTop: 14,
            padding: "10px 12px",
            background: "#FEF3C7",
            borderLeft: "3px solid #D97706",
            borderRadius: 4,
          }}
        >
          {help.notes.map((n, i) => (
            <div
              key={i}
              style={{ fontSize: 12.5, lineHeight: 1.5, marginTop: i ? 6 : 0 }}
            >
              {n}
            </div>
          ))}
        </div>
      ) : null}

      {help.rule ? (
        <div
          style={{
            marginTop: 12,
            fontSize: 11.5,
            color: "#8A94A6",
            borderTop: "1px solid #EDEFF3",
            paddingTop: 8,
          }}
        >
          <i className="fas fa-book" style={{ marginRight: 6 }} />
          Эх сурвалж: {help.rule}
        </div>
      ) : null}
    </>
  );
}
